import { Rainbow } from '@eliadmin/core/src/components/nt/ui/cmyk';
import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma „Visual“ (186:15198, 346 × 262): the CMYK rainbow „Dúha“ (186:15199, 345.52 × 185.22 – the
 * styleguide rainbow `Rainbow` at 1.4 ×) with „404“ (Heading/H1) centred 8 px below it. Decoration
 * only: the heading of the card says what happened. Below md the whole visual shrinks to 240 px.
 * The right padding of „404“ (one letter space) centres the digits as Figma does – CSS also applies
 * the negative letter spacing after the last digit, Figma does not. `label` – another sign in place
 * of „404“ (the error page's „!“, which is drawn without that padding: `trimSpacing={false}`).
 */
export function NotFoundVisual({
  label = '404',
  trimSpacing = true,
}: {
  label?: string;
  trimSpacing?: boolean;
}) {
  return (
    <div aria-hidden="true" className="flex shrink-0 flex-col items-center gap-2">
      <Rainbow className="w-[240px] md:w-[345.52px]" />
      <p
        className={cn(
          'nt-h1 text-[47px] text-[#0D110D] md:text-[68px]',
          trimSpacing && 'pr-[0.04em]',
        )}
      >
        {label}
      </p>
    </div>
  );
}
